import React from 'react';
import { View, Text, StyleSheet, Platform, Animated } from 'react-native';
import { RefreshCw } from './icons';

interface RefreshIndicatorProps {
  isVisible: boolean;
}

export const RefreshIndicator: React.FC<RefreshIndicatorProps> = ({ isVisible }) => {
  const animatedValue = React.useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    Animated.timing(animatedValue, {
      toValue: isVisible ? 1 : 0,
      duration: 150, // Faster animation
      useNativeDriver: true,
    }).start();
  }, [isVisible, animatedValue]);

  // Always render but control opacity via animation to prevent layout shifts
  // Conditional rendering would cause layout flicker

  return (
    <Animated.View
      style={[
        styles.container,
        {
          opacity: animatedValue,
          // Removed slide animation - just fade in/out
        },
      ]}
    >
      <View style={styles.indicator}>
        <Animated.View
          style={[
            styles.iconContainer,
            {
              transform: [
                {
                  rotate: animatedValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['0deg', '360deg'],
                  }),
                },
              ],
            },
          ]}
        >
          <RefreshCw size={16} color="#007bff" />
        </Animated.View>
        <Text style={styles.text}>Refreshing data...</Text>
      </View>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: Platform.select({
      web: 'fixed' as any,
      default: 'absolute',
    }),
    bottom: 20,
    left: 20,
    right: 20,
    alignItems: 'center',
    zIndex: Platform.select({
      web: 999999,
      default: 999,
    }),
    pointerEvents: 'none',
  },
  indicator: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 25,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 6,
    borderWidth: Platform.select({
      ios: 0,
      android: 0,
      web: 1,
    }),
    borderColor: '#e8e8e8',
    maxWidth: 200,
  },
  iconContainer: {
    marginRight: 8,
  },
  text: {
    fontSize: 14,
    color: '#333',
    fontWeight: '500',
  },
});